import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";

function PendingPartnersGrid() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<any>(0);

  let partnersDetail = [
    {
      name: "Jake Paul",
      email: "jakepaul@yopmail.com",
      status: 1,
      phone: "030100201211",
    },
    {
      name: "Emma Stone",
      email: "emmastone@yopmail.com",
      status: 0,
      phone: "030100322312",
    },
    {
      name: "Kate Wilson",
      email: "katewilson@yopmail.com",
      status: 1,
      phone: "030100322212",
    },
    {
      name: "Clint Barton",
      email: "clintbarton@yopmail.com",
      status: 1,
      phone: "030100322212",
    },
    {
      name: "Mat Damon",
      email: "matt123@yopmail.com",
      status: 1,
      phone: "030100322212",
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabs = [
    {
      value: 0,
      label: "Publishers Accounts",
    },
    {
      value: 1,
      label: "Authors Accounts",
    },
  ];

  return (
    <div className={styles.mainTableContainer}>
      <Box className={styles.tableHeadingContainer}>
        <div className={styles.headingContainer}>
          <div className={styles.heading}>Pending Partner Accounts</div>
          <div className={styles.subHeading}>
            Manage your newly registered partners account here, which has not
            got any MOU
          </div>
        </div>
        <div>
          <button
            className={styles.viewAllBtn}
            onClick={() =>
              navigate({
                pathname: routeConstant.partnerListings.path,
                search: `?users=pending`,
              })
            }
          >
            View All
          </button>
        </div>
      </Box>

      <Box>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          className={styles.tab}
          TabIndicatorProps={{
            style: {
              backgroundColor: "black",
            },
          }}
          sx={{
            "& .MuiTabs-flexContainer": {
              borderBottom: "1.5px solid #D9D9D9",
            },
          }}
        >
          {tabs?.map((item: any, index: any) => {
            return (
              <Tab
                sx={{
                  width: "50%",
                  maxWidth: "50%",
                  background: "white",
                }}
                label={
                  <div
                    className={classNames(
                      styles.tabs,
                      activeTab === item?.value && styles.active
                    )}
                  >
                    <label className={styles.tabLabel}> {item?.label}</label>
                  </div>
                }
              />
            );
          })}
        </Tabs>
      </Box>

      <div className={styles.tableMainContainer}>
        <TableContainer component={Paper} className={styles.tableContainer}>
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>MOU </TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {partnersDetail?.map((item: any, index: number, arr: any[]) => {
                return (
                  <TableRow
                    className={classNames(
                      arr?.length === 5 &&
                        index + 1 === arr?.length &&
                        styles.noBorder
                    )}
                  >
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={Images.UserPlaceholderImage}
                          alt="profile_picture"
                          className={styles.profilepic}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{item?.name}</label>
                          <label className={styles.publishingHouse}>
                            Publishing House
                          </label>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>Pending</TableCell>
                    <TableCell>
                      <div className={styles.actionContainer}>
                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title="View Profile"
                        >
                          <div onClick={()=>{}}>
                            <Icons.EyeIcon2 />
                          </div>
                        </Tooltip>

                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title="Create MOU"
                        >
                          <div>
                            <Icons.CreateActionIcon />
                          </div>
                        </Tooltip>
                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title="Support Chat"
                        >
                          <div>
                            <Icons.MsgActionIcon />
                          </div>
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default PendingPartnersGrid;
